import { ViewportState } from '../types';

export const DEFAULT_VIEWPORT: ViewportState = {
    latitude: 48.8589506,
    longitude: 2.2768488,
    zoom: 5,
};

export const MAP_CONFIG = {
    DEFAULT_ITEMS_PER_PAGE: 200,
    MAX_PAGES: 200,
    CLUSTER_MAX_ZOOM: 14,
    CLUSTER_RADIUS: 50,
};

export const FILTER_STATUS = ['MISE EN SERVICE', 'FIN DE MISE EN SERVICE', 'TRAVAUX DE POSE EFFECTUÉS', 'TRAVAUX DE POSE EFFECTUÉS AVEC RESERVES'] as const;

export const INITIAL_FILTER_STATE = {
    productSerialNumber: '',
    metadataAvatarTypeId: '',
    groupMetadataAvatarTypeId: '',
    productInstallationDateAfter: '',
    productInstallationDateBefore: '',
    productLastMaintenanceDateAfter: '',
    productLastMaintenanceDateBefore: '',
    productLastEmptyingDateAfter: '',
    productLastEmptyingDateBefore: '',
    productLastMaintenanceThresholdName: '',
    productLastEmptyingThresholdName: '',
    maintenanceIn3Months: false,
    maintenanceIn6Months: false,
    maintenanceIn12Months: false,
    maintenanceHors: false,
    vidangeIn3Months: false,
    vidangeIn6Months: false,
    vidangeIn12Months: false,
    vidangeHors: false,
    departmentCodes: [] as number[],
};

// Threshold levels and their priorities (higher number = higher priority)
export const THRESHOLD_LEVELS = {
    'threshold.level.1': 1,
    'threshold.level.2': 2,
    'threshold.level.3': 3,
} as const;

// Threshold colors
export const THRESHOLD_COLORS = {
    'threshold.level.1': '#4caf50', // verde/green
    'threshold.level.2': '#ff9800', // naranja/orange
    'threshold.level.3': '#ef2929', // rojo/red
    default: '#9e9e9e', // gris/gray for null values
} as const;
